import { FC } from 'react';

import * as ST from './styled';

interface IProps {
    isAccordion?: boolean,
    isOpen?: boolean,
    defaultOpen?: boolean,
    title: string | JSX.Element,
    onToggle?: () => void,
}

interface IInfoSection extends FC<IProps> {
    Content: typeof ST.CollapsingContent,
}

const InfoSection: IInfoSection = ({ isAccordion = true, defaultOpen, isOpen, title, onToggle, children }) => {
    const currentTitle = typeof title === 'string' ? <ST.Title>{title}</ST.Title> : title;

    return ((isAccordion && title)
        ? <ST.CollapsingWrapper
            title={currentTitle}
            open={isOpen}
            defaultOpen={defaultOpen}
            toggle={onToggle}
            className={'ym-hide-content'}
        >
            {children}
        </ST.CollapsingWrapper>
        : <ST.Wrapper className={'ym-hide-content'}>
            {currentTitle}
            {children}
        </ST.Wrapper>
    );
};

InfoSection.Content = ST.CollapsingContent;

export default InfoSection;
